<template>
    <Box title="保养实施列表" :SearchParams="IsSee" @SearchParams=" IsSee=true">
        <van-tabs @click="propconfirm" swipeable background="rgba(0,0,0,0)" line-width="20px" v-model="tabsIndex">
            <van-tab :title="'未执行('+Total+'台)'">
                <LoadingFooter  v-model="loading" :finished="finished" @load="onLoad" @scroll="IsSee=false">
                   <div class="ArrayItems">
                       <div class="items" v-for="item in list" @click="Preventionout(item,'Y')">
                           <div>
                               <img src="@/assets/img/Icon_1.png" />
                               <div>
                                   <div>
                                       <span class="ellipsis">{{item.JHMC}}</span>
                                       <img src="../../assets/img/right.png" />
                                   </div>
                                   <div>
                                       <div>
                                           <p>计划单号:</p>
                                           <p>资产编号:</p>
                                           <p>资产名称:</p>
                                           <p>执行周期:</p>

                                       </div>
                                       <div>
                                           <p class="ellipsis">{{item.JHDH}}</p>
                                           <p class="ellipsis">{{item.SBBH}}</p>
                                           <p class="ellipsis">{{item.SBMC}}</p>
                                           <p class="ellipsis">{{item.JCZQ}}</p>
                                       </div>
                                       <div class="button">
                                           <div>执行计划</div>
                                           <div @click.stop="stop(item)">终止计划</div>
                                       </div>
                                   </div>
                               </div>
                           </div>
                           <div>
                               <span>计划保养时间</span>
                               <span>{{item.JHJCRQ}}</span>
                           </div>
                       </div>
                   </div>
                </LoadingFooter>
            </van-tab>
            <van-tab :title="'已执行('+TotalSecond+'台)'">
                <LoadingFooter v-model="loadingSecond" :finished="finishedSecond" @load="onLoadSecond" @scroll="IsSee=false">
                    <div class="ArrayItems">
                        <div class="items" v-for="item in listSecond" @click="Preventionout(item,'N')">
                            <div>
                                <img src="@/assets/img/Icon_1.png" />
                                <div>
                                    <div>
                                        <span class="ellipsis">{{item.SSDH}}</span>
                                        <img src="../../assets/img/right.png" />
                                    </div>
                                    <div>
                                        <div>
                                            <p>计划单号:</p>
                                            <p>资产编号:</p>
                                            <p>资产名称:</p>
                                            <p>执行周期:</p>
                                        </div>
                                        <div>
                                            <p class="ellipsis">{{item.JHDH}}</p>
                                            <p class="ellipsis">{{item.SBBH}}</p>
                                            <p class="ellipsis">{{item.SBMC}}</p>
                                            <p class="ellipsis">{{item.JCZQ}}</p>
                                        </div>
                                        <div class="button">
                                            <div>查看</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <span>本次保养时间</span>
                                <span>{{$format(item.BCJCRQ,'YYYY-MM-DD')}}</span>
                            </div>
                        </div>
                    </div>
                </LoadingFooter>
            </van-tab>
        </van-tabs>
        <transition name="fade">
            <div class="menu" v-show="IsSee">
                <Field title="计划名称" placeholder="请输入计划名称" @onMessage="value => search.JHMC = value" />
                <Field title="资产名称" placeholder="请输入资产名称" @onMessage="value => search.SBMC = value" />
                <Field title="开始时间" placeholder="请选择" type="calendar" @onMessage="value => search.StarDate = value" />
                <Field title="结束时间" placeholder="请选择" type="calendar" @onMessage="value => search.EndDate = value" />
                <div class="search" @click="serach">查询</div>
            </div>
        </transition>
    </Box>
</template>

<script>
    import {ExistsEdorIng} from '../../../tool/api/api.js'
    import Box from '@/components/commonBox/commonBox'
    import Field from '../../components/field/field'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    export default {
        name: 'maintainImplementList_BS',
        data() {
            return {
                search: {
                    JHMC: null,
                    JCKS: null,
                    StarDate: null,
                    EndDate: null,
                },
                searchSecond: { //已执行搜索条件
                    JHMC: null,
                    JCKS: null,
                    StarDate: null,
                    EndDate: null,
                },
                loading: true,
                finished: false,
                list: [],
                touchStartY: 0,
                IsSee: false,
                page: 10,
                Total: 0,
                listSecond: [],
                tabsIndex: 0,

                pageSecond: 10, //已加载页码
                TotalSecond: 0, //已执行总数量
                loadingSecond: false, //已执行加载状态
                finishedSecond: false, //已执行显示状态
                touchStartYSecond: 0, //已执行滚动条滚动量
            }
        },
        components: {
            Box,
            Field,
            LoadingFooter
        },
        activated() {
            this.list = [];
            this.page = 1;
            this.loadDataDefault();
        },
        methods: {
            serach() {
                this.IsSee=false;
                if(this.tabsIndex===0){
                    this.list=[];
                    this.page=1;
                    this.loadDataDefault()
                }else if(this.tabsIndex===1){
                    this.listSecond=[];
                    this.pageSecond=1;
                    this.loadDataSecondDefault()
                }
            },
            onLoad() {
                if (!this.loading && !this.finished) {
                    this.page += 1;
                    this.loadDataDefault();
                }
            },
            stop(item) { //终止计划
                this.$Dialog.confirm({
                    message: '确定终止?'
                }).then(() => {
                    this.$post('api/BY/StopKeep', {
                        UserCode: this.$UserInfo.UserId,
                        Store: this.$UserInfo.StoreCode,
                        OrderNo: item.JHDH,
                        OrderType: 1,
                        NextKeepDate: item.JHJCRQ,
                        EquId: item.SBBH
                    }).then(result => {
                        this.$Toast(result.Msg);
                        if (result.Status) {
                            setTimeout(x => {
                                this.list = [];
                                this.loadDataDefault()
                            }, 2000);
                        }
                    })
                }).catch(() => {})
            },
            loadDataDefault() {
                this.$post('api/BY/BYList', {
                    Store: this.$UserInfo.StoreCode,
                    UserCode: this.$UserInfo.UserId,
                    EquName: this.search.SBMC,
                    StarDate: this.search.StarDate,
                    EndDate: this.search.EndDate,
                    JHMC: this.search.JHMC,
                    PageIndex: this.page,
                    PageSize: 10
                }).then(result => {
                    result=JSON.parse(result);
                    this.Total = result.total;
                    if (result.total > 0) {
                        this.list=[];
                        for (let i = 0; i < result.rows.length; i++) {
                            this.list.push(result.rows[i]);
                        }
                        if (this.page * 10 > this.Total) {
                            this.loading = false;
                            this.finished = true;
                        } else this.loading = false;
                    }
                });
            },
            /************************************已执行******************************************/
            propconfirm() {
                this.IsSee=false;
                this.tabsIndex===0?this.loadDataDefault():this.loadDataSecondDefault();
            },
            loadDataSecondDefault() {
                this.listSecond=[];
                this.$post('api/BY/BYList', {
                    Store: this.$UserInfo.StoreCode,
                    UserCode: this.$UserInfo.UserId,
                    EquName: this.search.SBMC,
                    StarDate: this.search.StarDate,
                    EndDate: this.search.EndDate,
                    JHMC: this.search.JHMC,
                    PageIndex: 1,
                    PageSize: this.pageSecond,
                    SFYZX: "Y"
                }).then(result => {
                    result=JSON.parse(result);
                    this.TotalSecond = result.total;
                    if (result.total > 0) {
                        this.listSecond=[];
                        for (let i = 0; i < result.rows.length; i++) {
                            this.listSecond.push(result.rows[i]);
                        }
                        if (this.pageSecond > this.TotalSecond) {
                            this.loadingSecond = false;
                            this.finishedSecond = true;
                        } else this.loadingSecond = false;
                    }
                });
            },
            onLoadSecond() { //已执行下拉加载数据
                if (!this.loadingSecond && !this.finishedSecond) {
                    this.pageSecond += 10;
                    this.loadDataSecondDefault();
                }
            },
            Preventionout(item, state) { //保养已执行点击事件
            //console.log(item);
                if(!item.EquId)
                {
                    item.EquId=item.SBBH;
                    item.EquName=item.SBMC;
                    item.DepName=item.KSMC;
                    item.KeepCycle=item.JCZQ;
                    item.OrderNo=item.JHDH;
                    item.Standards=item.SBXH;
                }

                ExistsEdorIng(3, state, 'MaintainImplementDefault', item);
            }
        }
    }
</script>

<style scoped lang="scss">
    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    .items {
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding-bottom: 20px;

        &>div {
            &:first-child {
                display: flex;
                padding: 34px 16px 27px 26px;
                box-sizing: border-box;
                border-bottom: 2px solid #EFEFEF;

                img {
                    width: 150px;
                    height: 150px;
                    border-radius: 4px;
                }

                &>div {
                    &:nth-child(2) {
                        margin-left: 16px;
                        flex: 1;

                        &>div {
                            display: flex;

                            &:first-child {
                                margin-bottom: 18px;
                                display: flex;

                                span:first-child {
                                    color: $TEXT-DARK-COLOR;
                                    font-weight: bold;
                                    font-size: 32px;
                                    flex: 1;
                                    width: 208px;
                                }

                                span:nth-child(2) {
                                    color: $TEXT-DARK-COLOR;
                                    font-size: 28px;
                                    margin-left: 10px;
                                    width: 158px;
                                    text-align: right;
                                }

                                img {
                                    width: 32px;
                                    height: 32px;
                                    margin-left: 10px;
                                }
                            }

                            &:nth-child(2) {
                                p {
                                    color: #999;
                                    font-size: 26px;
                                    line-height: 45px;
                                    height: 45px;
                                }

                                &>div:nth-child(2) {
                                    p {
                                        width: 200px;
                                    }
                                }
                            }
                        }

                        .button {
                            margin-left: 10px;
                            margin-top: 20px;

                            div {
                                width: 152px;
                                height: 60px;
                                border-radius: 30px;
                                background: $THEME-COLOR;
                                font-size: 26px;
                                color: #fff;
                                text-align: center;
                                line-height: 60px;
                                margin-bottom: 12px;
                            }
                        }
                    }
                }
            }

            &:last-child {
                margin-top: 16px;
                padding: 0 26px 0 31px;
                box-sizing: border-box;
                display: flex;

                span {
                    color: #999;
                    font-size: 26px;

                    &:first-child {
                        flex: 1
                    }
                }
            }
        }
    }

    .ArrayItems{
        margin-top: 100px;
    }
    .menu{
       margin-top: 100px;
    }
</style>



// WEBPACK FOOTER //
// src/page/maintainImplementList_BS/maintainImplementList_BS.vue